import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-check-label d-flex justify-content-center align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  class: "form-check-input",
  type: "checkbox",
  name: "subscriptions"
}, null, -1)
const _hoisted_3 = { class: "form-check-label user-select-none fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-check form-switch form-check-custom form-check-solid", [_ctx.sizeClass]])
  }, [
    _createElementVNode("label", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1)
    ])
  ], 2))
}